import { render, staticRenderFns } from "./SendPickupLocationControl.vue?vue&type=template&id=61c648ee&scoped=true"
import script from "./SendPickupLocationControl.vue?vue&type=script&lang=js"
export * from "./SendPickupLocationControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c648ee",
  null
  
)

export default component.exports